var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import iconSizes from '../../iconSizes';
/**
 * AlertCircleIcon
 */
var AlertCircleIcon = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'm' : _c, _d = _a.color, color = _d === void 0 ? 'black' : _d, title = _a.title;
    return (_jsxs("svg", __assign({ focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: '0 0 32 32', style: { width: iconSizes[size], height: iconSizes[size] }, role: "img", "aria-hidden": (_b = !title) !== null && _b !== void 0 ? _b : false }, { children: [title && _jsx("title", { children: title }, void 0),
            _jsx("g", __assign({ style: { fill: color } }, { children: _jsxs("svg", __assign({ viewBox: "0 0 24 24" }, { children: [_jsx("path", { d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-15c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1s1-.4 1-1V7c0-.6-.4-1-1-1zm0 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z" }, void 0),
                        _jsxs("g", __assign({ fillRule: "evenodd" }, { children: [_jsx("use", {}, void 0),
                                _jsx("use", { fillRule: "nonzero" }, void 0)] }), void 0)] }), void 0) }), void 0)] }), void 0));
};
export default AlertCircleIcon;
